export const TransactionType = {
  Income: 'INCOME',
  Cost: 'COST'
}
